import { Injectable, signal } from '@angular/core';
import { InvoiceDetailsView } from '../models/invoice-extract.types';

/** Key shared with InlineLoadingService while the detail fetch is in flight. */
export const INVOICE_DETAILS_LOADING_KEY = 'invoice-details-sidebar';

/**
 * Manages the invoice-details sidebar state at a global level so that the
 * sidebar can render outside stacking contexts, mirroring BidDetailsSidebarService.
 * The loading spinner itself is driven separately by InlineLoadingService.
 */
@Injectable({ providedIn: 'root' })
export class InvoiceDetailsSidebarService {
  readonly isOpen = signal(false);
  readonly data = signal<InvoiceDetailsView | null>(null);

  /** Opens the sidebar immediately, before the detail fetch resolves. */
  openEmpty(): void {
    this.data.set(null);
    this.isOpen.set(true);
  }

  open(view: InvoiceDetailsView): void {
    this.data.set(view);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    this.data.set(null);
  }
}
